import { trackUmamiEventBeacon } from "@analytics";
import {
	REGISTRATION_RECEIPT_COOKIE,
	reportRegistrationReceipt,
} from "@repo/auth/registration-receipt";

let pendingReport: Promise<"failed" | "none" | "sent"> | null = null;

function readCookie(name: string) {
	const prefix = `${encodeURIComponent(name)}=`;
	const cookie = document.cookie
		.split("; ")
		.find((part) => part.startsWith(prefix));
	if (!cookie) {
		return null;
	}

	try {
		return decodeURIComponent(cookie.slice(prefix.length));
	} catch {
		return null;
	}
}

function clearRegistrationReceipt() {
	document.cookie = `${encodeURIComponent(REGISTRATION_RECEIPT_COOKIE)}=; Max-Age=0; Path=/; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`;
}

// signup measures browser conversion after receiving a registration receipt.
// Canonical account counts come from the server's registration-created event.
export function reportRegistrationFromBrowser() {
	if (typeof document === "undefined") {
		return Promise.resolve<"none">("none");
	}
	if (pendingReport) {
		return pendingReport;
	}

	pendingReport = reportRegistrationReceipt({
		read: () => readCookie(REGISTRATION_RECEIPT_COOKIE),
		clear: clearRegistrationReceipt,
		send: (method) =>
			trackUmamiEventBeacon("signup", {
				method,
				trackingOrigin: "browser-receipt",
			}),
	}).finally(() => {
		pendingReport = null;
	});

	return pendingReport;
}
